/* Tejjari mobile long-description toggle */
class ProductDescriptionToggle extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    this.content = this.querySelector('.product__description-content');
    this.button = this.querySelector('.product__description-toggle');
    this.label = this.querySelector('.product__description-toggle-label');
    if (!this.content || !this.button || !this.label) return;

    this.mobileQuery = window.matchMedia('(max-width: 767.98px)');
    this.button.addEventListener('click', () => this.toggleDescription());
    this.mobileQuery.addEventListener('change', () => requestAnimationFrame(() => this.updateEligibility()));
    requestAnimationFrame(() => this.updateEligibility());
  }

  updateEligibility() {
    const shouldCollapse = this.mobileQuery.matches && this.content.scrollHeight > 380;
    this.classList.toggle('is-collapsible', shouldCollapse);
    if (!shouldCollapse) {
      this.classList.remove('is-expanded');
      this.button.hidden = true;
      this.button.setAttribute('aria-expanded', 'false');
      this.label.textContent = this.dataset.moreLabel;
      return;
    }
    this.button.hidden = false;
  }

  toggleDescription() {
    const expanded = !this.classList.contains('is-expanded');
    this.classList.toggle('is-expanded', expanded);
    this.button.setAttribute('aria-expanded', String(expanded));
    this.label.textContent = expanded ? this.dataset.lessLabel : this.dataset.moreLabel;
  }
}

if (!customElements.get('product-description-toggle')) {
  customElements.define('product-description-toggle', ProductDescriptionToggle);
}
